import React from 'react'

export const FileContents = ({ children }) => {
  return <span className="file-cta">{children}</span>
}
